export class BaseSearchRequest {
  public start?: number;
  public limit?: number;
  public sortBy?: string;
  public sortType?: string;
}
